export enum CHART_TYPE {
  PIE = 'pie',
  BAR = 'bar',
}